import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTButton from '../common/RTButton';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import UnassignedComplaints from './UnassignedComplaints';
import AssignedComplaints from './AssignedComplaints';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ComplaintManagement.css';
import RTPageLayout from '../common/RTPageLayout';

const ViewOpenComplaints = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('unassigned');

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="Open Complaints"
      actions={
        <>
          <RTButton variant="secondary" onClick={() => navigate(-1)}>
            ← Back
          </RTButton>
        </>
      }
      mainSection={true}
    >
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        id="complaints-tabs"
        className="rt-fullwidth-tabs"
        justify
      >
        <Tab
          eventKey="unassigned"
          title="Unassigned"
          style={{ minHeight: '60%', border: '0.5px solid #e0e0e0' }}
        >
          <UnassignedComplaints loadData={activeTab === 'unassigned'} />
        </Tab>
        <Tab
          eventKey="assigned"
          title="Assigned"
          style={{ minHeight: '60%', border: '0.5px solid #e0e0e0' }}
        >
          <AssignedComplaints loadData={activeTab === 'assigned'} />
        </Tab>
      </Tabs>
    </RTPageLayout>
  );
};

export default ViewOpenComplaints;
